import http from "./http_common";
import _ from "lodash";

class DrugServices {

  // constructor() {
  //   this.debouncedDrugList = _.debounce((medicineName) => {
  //    return this.fetchDrugList(medicineName);
  //   }, 150);
  // }

  // DrugList(medicineName) {
  //   return this.debouncedDrugList(medicineName);
  // }

  // fetchDrugList(medicineName) {
  //   return http.get(`/drugInfo/list/filter?medicineName=${medicineName}&pageNo=${1}`);
  // }

  fetchDrugList(medicineName) {
    // return http.get(`/drugInfo/listMdmDrug?medicineName=${medicineName}&pageNo=${1}&pageSize=${40}&pharmacyId=DZA5301051`);
    return http.get(`/ElasticSearch/listEsMdmDrug?medicineName=${medicineName}&pageNo=${1}&pageSize=${40}&pharmacyId=DZA5301051`);
  }

  fetchDrugListnew(medicineName) {
    return http.get(`/drugInfo/listMdmDrug?medicineName=${medicineName}&pageNo=1&pageSize=40`);
  }
  
}

export default new DrugServices();
